import { useRoutes } from 'react-router-dom';
import MainRoutes from './main-routes';
import AuthenticationRoutes from './authentication-routes';
import PublicRoutes from './public-routes';

export default function ThemeRoutes() {
  return useRoutes([PublicRoutes, AuthenticationRoutes, MainRoutes]);
}
